<template>
  <XCard class="py-6 px-4 mb-24">
    <div class="max-h-full h-auto py-2 px-16 overflow-hidden">
      <div>
        <div
          class="font-semibold text-lg mb-4"
          :class="{ 'text-center': question.type === 'rate' }">
          {{ question.name }}
        </div>

        <template v-if="!question.isFinished && !alreadyAnswered">
          <XStarRating
            v-if="question.type === 'rate'"
            ref="stars"
            class="w-full text-4xl"
            :starActiveClass="$style['star-active']"
            :starClass="$style['star']"
            v-model="answer"
            v-validate="'required'"
            data-vv-name="rate"
            :stars="5" />

          <div
            v-if="question.type === 'test'"
            class="text-left">
            <XRadio
              v-for="(questionAnswer, index) in question.answers"
              :key="index"
              name="answer"
              :label="questionAnswer"
              color="secondary"
              :fieldClass="['flex', 'mr-3', 'mb-3', 'text-grey-40']"
              :boxClass="{circle: [], box: ['mt-1 ', $style['box-size']]}"
              v-model="answer"
              :value="questionAnswer"
              v-validate="'required'"
              data-vv-name="test"
            />
          </div>

          <div class="text-center mt-6">
            <XButton
              color="primary"
              :loading="loading"
              @click="onSubmit">
              {{ $t('event.timeline.question.buttonActions.answer') }}
            </XButton>
          </div>

          <div
            v-if="validationErrors('rate')[0]"
            class="text-xs text-danger-40 text-center mt-3">
            {{ validationErrors('rate')[0] }}
          </div>

          <div
            v-if="validationErrors('test')[0]"
            class="text-xs text-danger-40 text-center mt-3">
            {{ validationErrors('test')[0] }}
          </div>

          <div
            v-if="errorMessage"
            class="mt-3 text-danger-50 text-center">
            {{ errorMessage }}
          </div>
        </template>

        <div
          v-else-if="alreadyAnswered"
          class="font-semibold text-center">
          {{ $t('event.timeline.question.messages.thanksToResponse') }}
        </div>

        <div
          v-else
          class="font-semibold text-center">
          {{ $t('event.timeline.question.messages.timeOver') }}
        </div>
      </div>
    </div>
  </XCard>
</template>

<script>
import gql from 'graphql-tag'
import { mapState } from 'vuex'

import XStarRating from '@plat/components/StarRating'

import FormValidation from '@common/mixins/FormValidation'

export default {
  mixins: [FormValidation],

  components: {
    XStarRating
  },

  props: {
    question: {
      type: Object
    }
  },

  data () {
    return {
      answer: this.question.type === 'test' ? '' : 0,
      loading: false,
      hasAnswered: false,
      errorMessage: ''
    }
  },

  computed: {
    ...mapState({
      attendeeId: state => state.routeParameters.attendee.id
    }),

    alreadyAnswered () {
      return this.hasAnswered || this.question.hasAnswered
    }
  },

  methods: {
    onSubmit () {
      if (this.loading) {
        return
      }

      this.loading = true
      this.errorMessage = ''

      this.validate()
        .then(isValid => {
          if (!isValid) {
            return
          }

          return this.questionAnswer()
        })
        .then(result => {
          if (result) {
            this.hasAnswered = true
          }
        })
        .catch(() => {
          this.errorMessage = this.$t('common.notifications.messages.requestError')
        })
        .finally(() => {
          this.loading = false
        })
    },

    questionAnswer () {
      return this.$apollo
        .mutate({
          mutation: gql`
            mutation QuestionAnswer($attendeeId: Uuid!, $ref: String!, $answer: String!) {
              attendee(attendeeId: $attendeeId) {
                questionAnswer(ref: $ref, answer: $answer) {
                  id
                  data
                }
              }
            }
          `,
          variables: {
            attendeeId: this.attendeeId,
            ref: this.question.ref,
            answer: this.answer
          }
        })
        .then(result => result.data.attendee.questionAnswer)
    }
  }
}
</script>

<style module>
.star-active {
  color: #fdd817;
}

.star {
  color: #c7c7c7;
}

.box-size {
  min-width: 1em;
  min-height: 1em;
}
</style>
